var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-page',{attrs:{"title":"Redirecionando..."}}),(_vm.concursos)?_c('form',{ref:"formConcursos",staticClass:"c-d-none",attrs:{"method":"POST","action":_vm.concursos.url}},[_c('input',{attrs:{"type":"hidden","name":"access_token"},domProps:{"value":_vm.concursos.token}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }